
import ClubList from '@/features/clubs/components/ClubList';
import ClubDebug from '@/features/clubs/components/ClubDebug';

export default function ClubsPage() {
  return (
    <div className="min-h-screen bg-black p-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-white mb-4">
            Venues
          </h1>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            Temporary Test Page
          </p>
        </div>
        
        {/* Temporary debug component */}
        <div className="mb-8">
          <ClubDebug />
        </div>
        
        <ClubList />
      </div>
    </div>
  );
}
